import { DocgenLocalEnv } from './docgenLocalEnv';

export function getDGConfig() {
	const config = {
		DOCGEN_BASE_URL: DocgenLocalEnv.DOCGEN_BASE_URL,
		CLIENT_ID: DocgenLocalEnv.CLIENT_ID,
	};
	return config;
}

export function isLocalDGSetup(): boolean {
	// try-catch to handle case when env variable not defined, it just throw process not defined error
	try {
		return (
			process.env.NODE_ENV === 'development' &&
			process.env.DOCGEN_PILET_USE_LOCAL_SERVICE === 'true'
		);
	} catch {}

	return false; // Uncomment this for production
}
